const updateAddDocumentServices = {
  toastr: 'Documento actualizado',
  toastr1: 'El documento fue actualizado con éxito'
};

export default updateAddDocumentServices;
